import CommunityGreetingImage_namespaceObject from "../../static/image/CommunityGreetingImage.png";
export default CommunityGreetingImage_namespaceObject;
